import { gql } from '@apollo/client';

export const PAGE_CATEGORY_FRAGMENT = gql`
  fragment Category on Category {
    brandKey
    body
    historyCount
    createdAt
    description
    format
    isHeadlined
    id
    level
    lockedAt
    lockedBy {
      avatarUrl
      email
      id
      name
    }
    medias
    parent {
      id
      title
    }
    publishedAt
    slug
    status
    subtitle
    tabs(first: 50, orderBy: order_ASC) {
      content
      createdAt
      description
      id
      isOnline
      order
      title
      type
      updatedAt
      metas
      slug
    }
    tags(first: 50) {
      tag {
        id
        title
      }
    }
    title
    updatedAt
    editedAt
    urls {
      id
      origin
      path
    }
  }
`;

export const PAGE_CATEGORY_LIST_FRAGMENT = gql`
  fragment CategoryList on Category {
    id
    title
    format
    medias
    updatedAt
    status
    level
    brandKey
    lockedBy {
      avatarUrl
      email
      id
      name
    }
    parent {
      id
      title
    }
    children(first: 1000, orderBy: title_ASC) {
      id
    }
  }
`;
